<template>
    <div>
        <span
            class="text-xs font-semibold inline-block py-1 px-2 rounded last:mr-0 mr-1"
            :class="styleClass">
            {{ labelDefault }}
        </span>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})
const { params } = toRefs(props)
const status = computed(() => params?.value?.data.status)

const labelDefault = computed(() => {
  if (status?.value === 1) {
    return $t('labels.readyShip')
  }

  if (status?.value === -1) {
    return $t('labels.vehicleModule.notReady')
  }
})
const styleClass = computed(() => {
  if (status?.value === 1) {
    return 'text-success-600 bg-success-200'
  }

  if (status?.value === -1) {
    return 'text-warning-600 bg-warning-200'
  }
})
</script>
